import { useState } from "react";
import { api, formatApiError } from "@/lib/apiClient";
import { toast } from "sonner";
import { mbtiInfo } from "@/lib/mbti";
import { Sparkles, X } from "lucide-react";

/* Versões do comunicado adaptadas por IA a cada tipo MBTI — editáveis antes de enviar. */
export default function PersonaVariants({ form, setForm }) {
  const [busy, setBusy] = useState(false);
  const [meta, setMeta] = useState(null);
  const variants = form.variants || {};
  const types = Object.keys(variants).sort();

  const adapt = async () => {
    setBusy(true);
    try {
      const r = await api.post("/communiques/personalize", {
        subject: form.subject, message: form.message, clubs: form.clubs, groups: form.groups,
      });
      setForm((f) => ({ ...f, variants: r.data.variants }));
      setMeta(r.data);
      toast.success(`${Object.keys(r.data.variants).length} versões prontas — revê antes de enviar`);
    } catch (err) { toast.error(formatApiError(err)); }
    setBusy(false);
  };

  return (
    <div className="space-y-3" data-testid="persona-variants">
      <div className="flex flex-wrap items-center gap-3">
        <button onClick={adapt} disabled={busy || form.message.trim().length < 5 || form.subject.trim().length < 3}
          className="kw-btn-secondary !py-2 text-[10px] inline-flex items-center gap-1.5" data-testid="persona-adapt">
          <Sparkles className="w-3 h-3" /> {busy ? "A adaptar a cada perfil…" : types.length ? "Adaptar outra vez" : "Adaptar com IA a cada perfil"}
        </button>
        {types.length > 0 && (
          <button onClick={() => { setForm((f) => ({ ...f, variants: null })); setMeta(null); }}
            className="text-[10px] uppercase tracking-widest font-bold text-[#737373] hover:text-white inline-flex items-center gap-1"
            data-testid="persona-clear"><X className="w-3 h-3" /> Usar só o texto base</button>
        )}
      </div>
      {meta?.no_mbti > 0 && (
        <p className="text-xs text-[#EAB308]" data-testid="persona-no-mbti">{meta.no_mbti} pessoas sem perfil MBTI recebem o texto base.</p>
      )}
      {types.map((t) => (
        <div key={t} className="bg-[#0F0F0F] border border-[#1F1F1F] p-3" data-testid={`persona-variant-${t}`}>
          <div className="text-[10px] uppercase tracking-widest font-bold mb-2 flex justify-between">
            <span style={{ color: mbtiInfo(t)?.color || "#A3A3A3" }}>{t} · {mbtiInfo(t)?.label || ""}</span>
            <span className="text-[#737373]">{meta?.counts?.[t] ?? ""} pessoas</span>
          </div>
          <textarea className="kw-input min-h-[110px] text-sm" value={variants[t]}
            onChange={(e) => setForm((f) => ({ ...f, variants: { ...f.variants, [t]: e.target.value } }))}
            data-testid={`persona-text-${t}`} />
        </div>
      ))}
    </div>
  );
}
